import { createSlice } from "@reduxjs/toolkit";

const modalSlicer = createSlice({
  name: "modal",
  initialState: {
    sidebarModal: false,
    postEditorModal: false,
  },
  reducers: {
    toggleSidebarModal: (state) => {
      state.sidebarModal = !state.sidebarModal;
    },

    togglePostEditorModal: (state, action) => {
      if (state.postEditorModal) {
        state.postEditorModal = false;
      } else {
        state.postEditorModal = action.payload;
      }
    },
  },
});

export const { toggleSidebarModal, togglePostEditorModal, toggleRepostModal } =
  modalSlicer.actions;
export default modalSlicer.reducer;
